'use client'
import {
  Button,
  Card,
  Image,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import NextImage from 'next/image'

import {
  ButtonProps,
  ImageProps,
  NormalizedSection,
  ParagraphProps,
  TitleProps,
} from '@/types'

import Slider from '@/components/molecules/Slider'
import { dispatchGTMEvent, GTM_EVENT_CATEGORY } from '@/helpers/gtm'
import DOMPurify from 'isomorphic-dompurify'

export interface ProductsListProps extends NormalizedSection {
  modelledContent: {
    title: TitleProps
    paragraph: ParagraphProps
    cta: ButtonProps
    items: {
      title: TitleProps
      image: ImageProps
      cta: any
    }[]
  }
}

const ProductsList = ({ modelledContent }: ProductsListProps) => {
  const { title, paragraph, items, cta } = modelledContent

  const handleCtaClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (cta.onClick) cta.onClick(event)
  }

  return (
    <Section className='section-products-list'>
      <div className='section-wrapper'>
        <div className='section-intro'>
          <div className='section-intro--content'>
            <Title
              {...title}
              dangerouslySetInnerHTML={{ __html: title.content || '' }}
            />
            <Paragraph
              as={'div'}
              dangerouslySetInnerHTML={{ __html: paragraph.content || '' }}
            />
            <Button
              animate
              as='a'
              {...cta}
              onClick={handleCtaClick}
            >
              {cta.content}
            </Button>
          </div>
        </div>
        {!!items && !!items.length && (
          <div className='section-content'>
            <Slider
              slidesPerView={2}
              spaceBetween={24}
              breakpoints={{
                // when window width is >= 640px
                640: {
                  slidesPerView: 3,
                  spaceBetween: 32,
                },
                // when window width is >= 1024
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 48,
                },
              }}
              slides={items.map((item, i) => {
                const { title, cta, image } = item
                const imageProps = {
                  src: image?.src || '',
                  alt: image?.alt || '',
                  width: image?.width || 400,
                  height: image?.height || 400,
                }

                const handleCtaClick = (
                  event: React.MouseEvent<HTMLButtonElement>
                ) => {
                  const sanitizedTitle = DOMPurify.sanitize(
                    title?.content ?? '',
                    {
                      USE_PROFILES: { html: false },
                    }
                  )

                  dispatchGTMEvent(GTM_EVENT_CATEGORY.PRODUCT, {
                    cta_clicked: sanitizedTitle,
                  })

                  if (cta.onClick) cta.onClick(event)
                }

                return (
                  <div
                    key={'Product-card' + i}
                    style={{ paddingBottom: 'var(--Spacing-M)' }}
                  >
                    <Card
                      className='Product-card--element'
                      animate
                      variant='default'
                    >
                      <Title
                        {...title}
                        dangerouslySetInnerHTML={{
                          __html: title.content || '',
                        }}
                      />
                      <div>
                        {/* `alt` attr already passed into imageProps */}
                        {/* eslint-disable-next-line jsx-a11y/alt-text */}
                        <Image
                          fit={image.fit}
                          as={NextImage}
                          className='product-image'
                          imageProps={imageProps}
                        />
                        <Button
                          animate
                          as='a'
                          {...cta}
                          size='small'
                          variant='themed'
                          onClick={handleCtaClick}
                        >
                          Scopri di più
                        </Button>
                      </div>
                    </Card>
                  </div>
                )
              })}
            />
          </div>
        )}
      </div>
    </Section>
  )
}

export default ProductsList
